// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Numeral = require("../../../utils/Numeral.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Core__Result = require("@rescript/core/src/Core__Result.bs.js");

function chain(state, validators) {
  var x = validators.map(function (validator) {
          return validator(state);
        }).find(function (v) {
        return Core__Result.isError(v);
      });
  if (x !== undefined && x.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: x._0
          };
  } else {
    return {
            TAG: "Ok",
            _0: state
          };
  }
}

function isRequired(str) {
  var match = Core__Option.map(str, (function (v) {
          return v.trim();
        }));
  if (match !== undefined && match !== "") {
    return {
            TAG: "Ok",
            _0: str
          };
  } else {
    return {
            TAG: "Error",
            _0: "is required"
          };
  }
}

function isNotNone(x) {
  if (x !== undefined) {
    return {
            TAG: "Ok",
            _0: x
          };
  } else {
    return {
            TAG: "Error",
            _0: "is required"
          };
  }
}

function isMoreThan(formatAsPriceOpt, min, num) {
  var formatAsPrice = formatAsPriceOpt !== undefined ? formatAsPriceOpt : false;
  if (num >= min) {
    return {
            TAG: "Ok",
            _0: min
          };
  }
  var formatted = formatAsPrice ? Numeral.formatPrice(min) : min.toString();
  return {
          TAG: "Error",
          _0: "must be more than " + formatted
        };
}

function isLessThan(formatAsPriceOpt, max, num) {
  var formatAsPrice = formatAsPriceOpt !== undefined ? formatAsPriceOpt : false;
  if (num <= max) {
    return {
            TAG: "Ok",
            _0: max
          };
  }
  var formatted = formatAsPrice ? Numeral.formatPrice(max) : max.toString();
  return {
          TAG: "Error",
          _0: "must be less than " + formatted
        };
}

function validateIfNotNone(value, otherValidator) {
  if (value === undefined) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var e = otherValidator(Caml_option.valFromOption(value));
  if (e.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: value
          };
  } else {
    return {
            TAG: "Error",
            _0: e._0
          };
  }
}

exports.chain = chain;
exports.isRequired = isRequired;
exports.isNotNone = isNotNone;
exports.isMoreThan = isMoreThan;
exports.isLessThan = isLessThan;
exports.validateIfNotNone = validateIfNotNone;
/* Numeral Not a pure module */
